import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVkPageView, trackVkRouteGoals } from '../utils/vkPixel';

/**
 * Sends Top.Mail.Ru pageView on SPA navigations (initial hit comes from index.html).
 */
export default function VkPixelTracker() {
    const location = useLocation();
    const prevPathRef = useRef(null);

    useEffect(() => {
        const path = `${location.pathname}${location.search}`;

        if (prevPathRef.current === null) {
            prevPathRef.current = path;
            trackVkRouteGoals(location.pathname);
            return;
        }

        if (prevPathRef.current === path) return;

        prevPathRef.current = path;
        trackVkPageView();
        trackVkRouteGoals(location.pathname);
    }, [location.pathname, location.search]);

    return null;
}
